import posthog from "posthog-js";
import { isProduction } from "@/Environment";

export function trackPostHogEvent(
  name: string,
  properties?: Record<string, unknown>,
): void {
  if (!isProduction()) {
    return;
  }

  posthog.capture(name, properties);
}
